import { EditorContent } from '@tiptap/react'
import React, { useRef } from 'react'

import { useBlockEditor } from '@/tiptap/hooks/useBlockEditor'

import '@/tiptap/styles/index.css'
import '@/tiptap/styles/partials/animations.css';
import '@/tiptap/styles/partials/blocks.css';
import '@/tiptap/styles/partials/code.css';
import '@/tiptap/styles/partials/collab.css';
import '@/tiptap/styles/partials/lists.css';
import '@/tiptap/styles/partials/placeholder.css';
import '@/tiptap/styles/partials/table.css';
import '@/tiptap/styles/partials/typography.css';



import { TableColumnMenu, TableRowMenu } from '@/tiptap/extensions/Table/menus'
import { TextMenu } from '../menus/TextMenu'
import { ContentItemMenu } from '../menus/ContentItemMenu'
import * as Y from 'yjs'

export const BlockEditor = ({
  content,
  readOnly,
  enableBold,
  onContentChange,
  aiToken,
  ydoc,
  provider,
}: {
  aiToken?: string
  hasCollab: boolean
  ydoc: Y.Doc
  provider?: null | undefined
}) => {
  const menuContainerRef = useRef(null)

  const { editor } = useBlockEditor({ enableBold, aiToken, ydoc, provider, content, onContentChange, readOnly })

  React.useEffect(() => {
    if (!editor) {
      return undefined
    }

    editor.setEditable(!readOnly)
  }, [editor, readOnly])

  if (!editor) {
    return null
  }

  return (
    <div className="flex h-full" ref={menuContainerRef}>
      <EditorContent editor={editor} className="flex-1 overflow-y-hidden" />
      <ContentItemMenu editor={editor} />
      <TextMenu enableBold={enableBold} editor={editor} />
      <TableRowMenu editor={editor} appendTo={menuContainerRef} />
      <TableColumnMenu editor={editor} appendTo={menuContainerRef} />
    </div>
  )
}

export default BlockEditor
